import { Typography, Card } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

export default function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div style={{ maxWidth: 1000, margin: '0 auto', padding: '40px 24px' }}>
      <div style={{ marginBottom: 24 }}>
        <a onClick={() => navigate(-1)} style={{ cursor: 'pointer' }}>
          <ArrowLeftOutlined /> 返回
        </a>
      </div>
      
      <Card>
        <Typography>
          <Title level={1}>隐私政策</Title>
          <Paragraph>
            <Text type="secondary">最后更新日期: {new Date().toLocaleDateString('zh-CN')}</Text>
          </Paragraph>

          <Title level={2}>1. 引言</Title>
          <Paragraph>
            TraderMind（以下简称"我们"）尊重并保护用户的隐私。本隐私政策说明了我们如何收集、使用、
            存储和保护您的个人信息。
          </Paragraph>

          <Title level={2}>2. 我们收集的信息</Title>
          <Title level={3}>2.1 您提供的信息</Title>
          <Paragraph>
            • 账户信息：邮箱地址、昵称、头像
          </Paragraph>
          <Paragraph>
            • 交易数据：交易记录、交易品种、盈亏数据
          </Paragraph>
          <Paragraph>
            • 情绪数据：情绪日志、心理状态记录
          </Paragraph>
          <Paragraph>
            • 检查清单：交易前检查清单的填写记录
          </Paragraph>

          <Title level={3}>2.2 自动收集的信息</Title>
          <Paragraph>
            • 设备信息：设备类型、操作系统版本
          </Paragraph>
          <Paragraph>
            • 使用数据：访问时间、使用功能、操作记录
          </Paragraph>
          <Paragraph>
            • 日志信息：IP地址、浏览器类型、访问页面
          </Paragraph>

          <Title level={2}>3. 信息使用方式</Title>
          <Paragraph>
            我们使用收集的信息用于：
          </Paragraph>
          <Paragraph>
            3.1 提供、维护和改进我们的服务
          </Paragraph>
          <Paragraph>
            3.2 生成个性化的分析报告和建议
          </Paragraph>
          <Paragraph>
            3.3 与您沟通，包括发送服务更新和技术通知
          </Paragraph>
          <Paragraph>
            3.4 监控和分析使用趋势，以改善用户体验
          </Paragraph>
          <Paragraph>
            3.5 检测、预防和解决技术问题
          </Paragraph>

          <Title level={2}>4. 信息共享</Title>
          <Paragraph>
            我们不会出售、交易或出租您的个人信息给第三方。我们可能在以下情况下共享信息：
          </Paragraph>
          <Paragraph>
            4.1 经您同意的情况下
          </Paragraph>
          <Paragraph>
            4.2 为了遵守法律法规或响应法律程序
          </Paragraph>
          <Paragraph>
            4.3 保护我们或他人的权利、财产或安全
          </Paragraph>
          <Paragraph>
            4.4 与服务提供商共享（如云存储服务），但这些提供商必须遵守严格的保密协议
          </Paragraph>

          <Title level={2}>5. 数据安全</Title>
          <Paragraph>
            我们采取合理的技术和组织措施来保护您的个人信息：
          </Paragraph>
          <Paragraph>
            5.1 使用加密技术保护数据传输
          </Paragraph>
          <Paragraph>
            5.2 密码使用安全哈希算法存储
          </Paragraph>
          <Paragraph>
            5.3 定期进行安全审计和漏洞扫描
          </Paragraph>
          <Paragraph>
            5.4 限制员工访问个人数据的权限
          </Paragraph>

          <Title level={2}>6. 数据保留</Title>
          <Paragraph>
            我们将保留您的个人信息，只要您的账户处于活跃状态或需要为您提供服务。
            如果您希望删除您的账户或请求我们不再使用您的信息，请联系我们。
          </Paragraph>

          <Title level={2}>7. 您的权利</Title>
          <Paragraph>
            您对您的个人信息享有以下权利：
          </Paragraph>
          <Paragraph>
            7.1 访问权：您可以请求访问我们持有的关于您的个人信息
          </Paragraph>
          <Paragraph>
            7.2 更正权：您可以更新或更正不准确的个人信息
          </Paragraph>
          <Paragraph>
            7.3 删除权：您可以请求删除您的个人信息
          </Paragraph>
          <Paragraph>
            7.4 数据可携权：您可以请求以结构化、常用的格式接收您的数据
          </Paragraph>
          <Paragraph>
            7.5 撤回同意权：您可以随时撤回对数据处理的同意
          </Paragraph>

          <Title level={2}>8. Cookie和类似技术</Title>
          <Paragraph>
            我们使用Cookie和类似技术来：
          </Paragraph>
          <Paragraph>
            8.1 记住您的登录状态
          </Paragraph>
          <Paragraph>
            8.2 了解您如何使用我们的服务
          </Paragraph>
          <Paragraph>
            8.3 改善用户体验
          </Paragraph>
          <Paragraph>
            您可以通过浏览器设置管理Cookie偏好，但这可能影响某些功能的使用。
          </Paragraph>

          <Title level={2}>9. 儿童隐私</Title>
          <Paragraph>
            我们的服务不面向18岁以下的儿童。我们不会有意收集18岁以下儿童的个人信息。
          </Paragraph>

          <Title level={2}>10. 隐私政策的变更</Title>
          <Paragraph>
            我们可能会不时更新本隐私政策。我们会在本页面上发布新的隐私政策，
            并更新"最后更新日期"。重大变更时，我们会通过邮件或服务内通知您。
          </Paragraph>

          <Title level={2}>11. 联系我们</Title>
          <Paragraph>
            如果您对本隐私政策有任何疑问或顾虑，请通过以下方式联系我们：
          </Paragraph>
          <Paragraph>
            邮箱: privacy@tradermind.com
          </Paragraph>
          <Paragraph>
            我们会在收到您的请求后30天内回复。
          </Paragraph>
        </Typography>
      </Card>
    </div>
  );
}
